.c{display:flex;}